import { ReactElement } from "react"

import DownloadButton from "./downloadButton"
import { Datasets } from "../../constants/enums"
import { DOWNLOAD } from "../../services/middleware/urls/hybrid"

interface IDownloadDatasetButtonProps {
    dataset: Datasets
}

/**
 * Button which allows user to download data from demandDeviceSearch and
 * genDeviceSearch. This button should only be exposed to ENA sys admin users.
 * @example
 * <DownloadDatasetButton dataset={dataset} />
 */
const DownloadDatasetButton = ({
    dataset,
}: IDownloadDatasetButtonProps): ReactElement => (
    <DownloadButton urlOrFetcher={DOWNLOAD(dataset)} sensitiveDataWarning />
)

export default DownloadDatasetButton
